var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    viewBox: "0 0 120 150",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#61bb46",
    d: "M4.38.94h18.5v18.5H4.37z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1eaa4a",
    d: "M4.38 19.44h18.5v18.5H4.37z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#39b54a",
    d: "M4.38 37.93h18.5v18.5H4.37z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2aa449",
    d: "M4.38 56.43h18.5v18.5H4.37z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7ec352",
    d: "M22.87.94h18.5v18.5h-18.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#61bb46",
    d: "M22.87 19.44h18.5v18.5h-18.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1eaa4a",
    d: "M22.87 37.93h18.5v18.5h-18.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0bb14b",
    d: "M22.87 56.43h18.5v18.5h-18.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2be35",
    d: "M41.37.94h18.5v18.5h-18.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb892c",
    d: "M41.37 19.44h18.5v18.5h-18.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2162a1",
    d: "M4.38 111.9h18.5v18.5H4.37z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2475a8",
    d: "M4.38 130.4h18.5v18.5H4.37z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#eea336",
    d: "M59.86.94h18.5v18.5h-18.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#d67438",
    d: "M59.86 19.44h18.5v18.5h-18.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#1490ba",
    d: "M22.87 111.9h18.5v18.5h-18.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#32559a",
    d: "M22.87 130.4h18.5v18.5h-18.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#48b2cd",
    d: "M41.37 74.92h18.5v18.5h-18.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#12a0d2",
    d: "M59.86 74.92h18.5v18.5h-18.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea8034",
    d: "M78.36.94h18.5v18.5h-18.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#c15c2f",
    d: "M78.36 19.44h18.5v18.5h-18.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#de8081",
    d: "M78.36 37.93h18.5v18.5h-18.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#af1d2b",
    d: "M78.36 56.43h18.5v18.5h-18.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#cd733a",
    d: "M96.85.94h18.5v18.5h-18.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea802c",
    d: "M96.85 19.44h18.5v18.5h-18.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#c656a0",
    d: "M96.85 37.93h18.5v18.5h-18.5z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#9a4990",
    d: "M96.85 56.43h18.5v18.5h-18.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#c71f35",
    d: "M78.36 74.92h18.5v18.5h-18.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#981b41",
    d: "M96.85 74.92h18.5v18.5h-18.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#1073a2",
    d: "M41.37 93.42h18.5v18.5h-18.5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b90b3",
    d: "M59.86 93.42h18.5v18.5h-18.5z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#981b41",
    d: "M78.36 93.42h18.5v18.5h-18.5z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#c82254",
    d: "M96.85 93.42h18.5v18.5h-18.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.118c02076e1ea5b32ad553724f7be2da.svg";
export { ForwardRef as ReactComponent };